<template>
  <button v-if="thumbnailUrl && !hasError"
          type="button"
          class="part-thumbnail-preview-button"
          data-unit="part-collection-thumbnail-preview"
          :aria-label="$t('clickToEnlarge')"
          @click.stop="$emit('preview')">
    <stateless-thumbnail :is-widget="isWidget"
                         :thumbnail-url="thumbnailUrl"
                         thumbnail-type="part"
                         class="is-32x32 is-flex is-align-items-center"
                         @errorLoading="hasError = true" />
  </button>
  <figure v-else
          class="image is-32x32 part-thumbnail"
          data-unit="part-collection-thumbnail-placeholder" />
</template>

<script setup lang="ts">
import { ref, watch } from 'vue'
import StatelessThumbnail from '@/components/common/StatelessThumbnail.vue'

const props = defineProps<{
  thumbnailUrl?: string
  isWidget?: boolean
}>()

defineEmits<{
  (e: 'preview'): void
}>()

const hasError = ref(false)

watch(() => props.thumbnailUrl, () => {
  hasError.value = false
})
</script>

<style scoped>
.part-thumbnail-preview-button {
  align-items: center;
  background: transparent;
  border: 0;
  cursor: pointer;
  display: flex;
  justify-content: center;
  padding: 0;
}

.part-thumbnail-preview-button:focus-visible {
  outline: 2px solid currentColor;
  outline-offset: 2px;
}
</style>
